import { Routes } from '@angular/router';

import { EditLandlordStepsGuard } from '../../guards/edit-landlord-steps.guard';

export const editLandlordStepsRoutes: Routes = [
  {
    path: 'authentication',
    loadComponent: () =>
      import('./authentication/authentication.component').then(
        m => m.AuthenticationComponent
      ),
    title: 'landlords.registration_step_1'
  },
  {
    path: 'preferences',
    loadComponent: () =>
      import('./preferences/preferences.component').then(
        m => m.PreferencesComponent
      ),
    canActivate: [EditLandlordStepsGuard],
    title: 'landlords.registration_step_2',
    data: {
      requireCompletion: 'authentication'
    }
  },
  {
    path: 'payment',
    loadComponent: () =>
      import('./payment-method/payment-method.component').then(
        m => m.PaymentMethodComponent
      ),
    canActivate: [EditLandlordStepsGuard],
    title: 'landlords.registration_admin_step_3',
    data: {
      requireCompletion: 'preferences'
    }
  },
  {
    path: 'objectHierarchy',
    loadComponent: () =>
      import('./object-hierarchy/object-hierarchy.component').then(
        m => m.ObjectHierarchyComponent
      ),
    canActivate: [EditLandlordStepsGuard],
    title: 'landlords.registration_admin_step_object_hierarchy',
    data: {
      requireCompletion: 'payment'
    }
  },
  {
    path: 'subscription',
    loadComponent: () =>
      import('./subscription/subscription.component').then(
        m => m.SubscriptionComponent
      ),
    canActivate: [EditLandlordStepsGuard],
    title: 'landlords.registration_admin_step_4',
    data: {
      requireCompletion: 'payment'
    }
  }
];

export const editLandlordChildRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'authentication'
  },
  ...editLandlordStepsRoutes
];
